<template>
  <div class="page-content">
    <div class="account-payable">
      <h1 class="page-title">{{ $locale("sideMenu.accountPayable.management") }}</h1>

      <!-- Search Area -->
      <el-row :gutter="10" class="search-area">
        <el-col :span="14">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input :placeholder="$locale('global.name')" v-model="filter.name" @keyup.enter.native="search_fn">
                <i slot="suffix" class="el-input__icon el-icon-search" @click="search_fn"></i>
              </el-input>
            </el-col>
            <el-col :span="4">
              <el-button class="egl-btn-yellow" @click="search_fn">{{$locale("global.search")}}</el-button>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="10" class="ta-r">
          <el-button class="egl-btn-yellow" @click="exportCSV_fn">{{ $locale("global.exportToCSV") }}</el-button>
          <el-button :class="notApprove > 0 ? 'egl-btn-yellow' : 'egl-btn-gray'" @click="approve_fn">{{ $locale("global.approve") }}</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="10" class="search-area">
        <el-col :span="24" class="ta-r">
          <el-button class="egl-btn-yellow" @click="showDialog_fn('ticketing')">{{ $locale("accountPayable.filmFeeFegistration") }}</el-button>
          <el-button class="egl-btn-yellow" @click="showDialog_fn('purchase')">{{ $locale("accountPayable.purchasePurchaseRegistration") }}</el-button>
          <el-button class="egl-btn-yellow" @click="showDialog_fn('proxy')">{{ $locale("accountPayable.consignmentPurchaseRegistration") }}</el-button>
          <el-button class="egl-btn-yellow" @click="showDialog_fn('otherPurchase')">{{ $locale("accountPayable.otherPurchaseRegistration") }}</el-button>
          <el-button class="egl-btn-yellow" @click="showDialog_fn('oneTimePayment')">{{ $locale("accountPayable.oneTimePaymentRegistration") }}</el-button>
        </el-col>
      </el-row>

      <el-table :data="tableData" class="egl-table list-table result-table" stripe @sort-change="sort_fn" :span-method="spanMethod" :cell-class-name="setCellClassName" width="100%">
        <el-table-column :label="$locale('global.change')" width="50" align="center">
          <template slot-scope="scope">
            <i class="el-icon-circle-check change" v-show="!scope.row.approve"></i>
          </template>
        </el-table-column>

        <el-table-column min-width="120">
          <template slot="header" slot-scope="scope">
            <el-dropdown :hide-on-click="false">
              <span class="el-dropdown-link">{{ $locale("global.type") }}<i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-checkbox-group v-model="theadFilter.type" @change="theadFilter_fn">
                  <el-dropdown-item v-for="typeObj in typeList" :key="typeObj.value">
                    <el-checkbox :label="typeObj.value">{{ typeObj.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.type }}</span>
          </template>
        </el-table-column>

        <template v-for="th in thead">
          <el-table-column :label="th.label" :prop="th.prop" :key="th.prop" v-if="th.sort" sortable="custom" :align="th.align" :min-width="th.width"></el-table-column>
          <el-table-column :label="th.label" :prop="th.prop" :key="th.prop" :align="th.align" v-else :min-width="th.width"></el-table-column>
        </template>

        <el-table-column :label="$locale('global.control')" align="center" width="240">
          <template slot-scope="scope">
            <div class="handle" v-if="scope.$index != tableData.length - 1">
              <template v-if="scope.row.monthLock == true">
                <a @click="cancel_fn(scope.$index)">{{ $locale("global.cancel") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="showDetail(scope.$index)">{{ $locale("global.detail") }}</a>
              </template>
              <template v-else>
                <a @click="showPaymentRegistration(scope.$index)" v-if="scope.row.accountPayableBalance != '0'">{{ $locale("accountPayable.paymentRegistration") }}</a>
                <a v-else class="gray-handle">{{ $locale("accountPayable.paymentRegistration") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="showDetail(scope.$index)">{{ $locale("global.detail") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="showDetail(scope.$index, 'edit')">{{ $locale("global.edit") }}</a>
                <el-divider direction="vertical"></el-divider>
                <a @click="delete_fn(scope.$index)">{{ $locale("global.delete") }}</a>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <CommPagination
        :total="pageCount"
        :curPage="onSearch.page"
        :pageSize="onSearch.pageSize"
        @current-change="choosePage"
      />

      <OtherPurchaseDialog
        v-bind:isShow="showDialog.otherPurchase"
        v-bind:actionType="dialogAction"
        v-bind:cinemaList="cinemaList"
        v-bind:clientList="clientList"
        v-bind:formMsg="dialogMsg"
        v-bind:accountPayableArr="accountPayableArr"
        @closeFn="colseDialog"
        @refreshTable="refreshTable"
        @showPaymentRegistration="showPaymentRegistration"
      ></OtherPurchaseDialog>

      <OneTimePaymentDialog
        v-bind:isShow="showDialog.oneTimePayment"
        v-bind:bankAccountList="bankAccountList"
        v-bind:accountReceivableList="accountReceivableList"
        v-bind:originalTable="originalData"
        @closeFn="colseDialog"
        @refreshTable="refreshTable"
        @openOneTimePaymentDetail="openOneTimePaymentDetail"
        ref="oneTimePayment"
      ></OneTimePaymentDialog>
      <TicketingDialog
        v-bind:isShow="showDialog.ticketing"
        v-bind:actionType="dialogAction"
        v-bind:clientList="clientList"
        v-bind:forMsg="dialogMsg"
        v-bind:accountPayableArr="accountPayableArr"
        v-bind:roundType="roundType"
        @closeFn="colseDialog"
        @refreshTable="refreshTable"
        @showPaymentRegistration="showPaymentRegistration"
      />
      <PurchaseDialog
        v-bind:isShow="showDialog.purchase"
        v-bind:actionType="dialogAction"
        v-bind:clientList="clientList"
        v-bind:forMsg="dialogMsg"
        v-bind:accountPayableArr="accountPayableArr"
        v-bind:roundType="roundType"
        @closeFn="colseDialog"
        @refreshTable="refreshTable"
        @showPaymentRegistration="showPaymentRegistration"
      />
      <ProxyDialog
        v-bind:isShow="showDialog.proxy"
        v-bind:actionType="dialogAction"
        v-bind:clientList="clientList"
        v-bind:forMsg="dialogMsg"
        v-bind:accountPayableArr="accountPayableArr"
        v-bind:roundType="roundType"
        @closeFn="colseDialog"
        @refreshTable="refreshTable"
        @showPaymentRegistration="showPaymentRegistration"
      />
      <PaymentRegistration
        v-bind:isShow="showDialog.paymentRegistration"
        v-bind:formMsg="paymentRegistrationMsg"
        v-bind:accountPayableMsg="accountPayableMsg"
        v-bind:actionType="paymentRegistrationAction"
        v-bind:accountReceivableList="accountReceivableList"
        ref="paymentRegistration"
        @closeFn="colsePaymentRegistrationDialog"
        @refreshList="refreshPaymentTable"
        @refreshTable="refreshTable"
        @openOffsetDialog="obj => openOffsetDialog(obj, 'paymentRegistration')"
      ></PaymentRegistration>

      <OffsetDialog
        v-bind:isShow="showDialog.offset"
        v-bind:basicObj="offsetBasic"
        @closeFn="closeOffsetDialog"
        @setOffset="setOffset"
      ></OffsetDialog>

      <OneTimePaymentDetailDialog
        v-bind:isShow="showDialog.oneTimePaymentDetail"
        @closeFn="closeOneTimePaymentDetail"
        @setPaymentDetails="setOneTimePaymentDetaile"
        @openOffsetDialog="obj => openOffsetDialog(obj, 'oneTimePaymentDetail')"
        ref="oneTimePaymentDetail"
      ></OneTimePaymentDetailDialog>
    </div>
  </div>
</template>

<script>
import { createColumn, formatData, createTypeList } from "@/assets/js/accountPayable.js";
import {
  getAccountPayableListMap,
  getCinemaList,
  deleteAccountPayable,
  getAccountPayablePaymentList,
  exportCSV,
  approveFn,
  getAccountReceivableListMap,
  getBankAccountList,
  cancelAccountPayable,
} from "@/helpers/service/api/accountPayable.js";
import { getSystemSetting, getClientListService } from "@/helpers/service/api/common.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import OneTimePaymentDialog from "@/components/AccountPayable/OneTimePaymentDialog.vue";
import OtherPurchaseDialog from "@/components/AccountPayable/OtherPurchaseDialog.vue";
import TicketingDialog from "@/components/AccountPayable/AccountsPayableManagement.vue";
import PurchaseDialog from "@/components/AccountPayable/PurchaseDialog.vue";
import ProxyDialog from "@/components/AccountPayable/ProxyDialog.vue";
import PaymentRegistration from "@/components/AccountPayable/PaymentRegistration.vue";
import CommPagination from "@/components/common/CommPagination";
import countDownAlert from "@/utils/countDownAlert";
import { mapState, mapActions } from "vuex";
import OffsetDialog from "@/components/AccountPayable/OffsetDialog.vue";
import OneTimePaymentDetailDialog from "@/components/AccountPayable/PaymentDetailDialog.vue";
import "@/assets/style/accountPayable.less";
import { getApiKeysField } from "@/utils/getApiKeys";

export default {
  name: "AccountPayable",
  provide() {
    return {
      accReceivableList: () => this.provideAccountReceivableList,
      clientList: () => this.provideClientList,
    };
  },
  data() {
    return {
      providePage: 0,
      filter: {
        name: "",
      },
      onSearch: {
        name: "",
        page: 0,
        pageSize: 10,
        paging: true,
        sort: [],
        type: [],
        brandId: "",
      },
      notApprove: 0,
      typeList: createTypeList(),
      originalData: [],
      thead: [],
      tableData: [],
      theadFilter: {
        type: [],
      },
      pageCount: 0,
      showDialog: {
        otherPurchase: false,
        oneTimePayment: false,
        ticketing: false,
        purchase: false,
        proxy: false,
        paymentRegistration: false,
        offset: false,
        oneTimePaymentDetail: false
      },
      dialogMsg: {},
      paymentRegistrationMsg: {},
      paymentRegistrationAction: "create",
      accountPayableMsg: {},
      dialogAction: "",
      clientList: [],
      cinemaList: [],
      accountPayableArr: [],
      paymentItem: {},// do some thing
      roundType: "",
      accountReceivableList: [],
      provideAccountReceivableList: [],
      provideClientList: [],
      bankAccountList: [],
      offsetBasic: {},
      offsetComponentRef: "",
      
    };
  },
  computed: {
    ...mapState("app", {
      brandId: state => state.brandId,
      token: state => state.token,
      accountReceivablePar: state => `brandId=${state.brandId}&page=0&pageSize=9999`
    }),
  },
  methods: {
    ...mapActions("api", ["setClientList", "setBankAccountList", "setCinemaList", "setInvoiceList"]),
    search_fn() {
      this.onSearch = { ...this.onSearch, ...this.filter };
      this.getDate_fn();
    },
    getDate_fn() {
      let that = this;
      let params = JSON.parse(JSON.stringify(this.onSearch));

      requestAll([
        getAccountPayableListMap({
          ...params,
          field: [
            ...this.thead.reduce((fields, th) => th.apiProp !== null ? [...fields, th.apiProp] : fields, []),
            // need followings in one time payment dialog
            "targetSourceList", "type",
          ]
        }),
        // getClientListService({
        //   page: 0,
        //   pageSize: 9999,
        //   field: ["id", "name", "clientCode", "groupName", "aliasName"]
        // }),
        getCinemaList(),
        // getAccountReceivableList(accountReceivablePar),
        getBankAccountList(),
      ]).then(res => {
        let { notApprove, tableData } = formatData(res[0].data.data, that.typeList);

        that.notApprove = notApprove;
        that.tableData = tableData;
        that.pageCount = res[0].data.count || 0;
        that.originalData = res[0].data.data;
        // that.clientList = res[1].data.data;
        that.cinemaList = res[1].data.data;
        // that.accountReceivableList = res[2].data.data;
        that.bankAccountList = res[2].data;

        // that.setClientList(res[1].data.data);
        that.setBankAccountList(res[2].data);
        that.setCinemaList(res[1].data.data);
        // that.setInvoiceList(res[2].data.data);
      });
    },
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1
      };

      this.getDate_fn();
    },
    showDialog_fn(keyName, action = "registration") {
      const that = this;
      let dialog = { ...this.showDialog };
      dialog[keyName] = true;
      const openModal = () => {
        that.showDialog = dialog;
        that.dialogAction = action;
      };
      switch(keyName) {
      case "otherPurchase":
      case "oneTimePayment":
        getCinemaList().then(res => {
          that.cinemaList = res.data.data;
          that.setCinemaList(res.data.data);
          openModal();
        });
        break;
      default:
        openModal();
        break;
      }
    },
    colseDialog() {
      let dialog = { ...this.showDialog };

      Object.keys(dialog).map(keyName => {
        dialog[keyName] = false;
      });

      this.showDialog = dialog;
      this.dialogAction = "";
      this.dialogMsg = {};
      this.accountPayableArr = [];
      this.paymentItem = {};// do some thing
    },
    colsePaymentRegistrationDialog() {
      let dialog = { ...this.showDialog };

      dialog.paymentRegistration = false;

      this.showDialog = dialog;
      // this.dialogAction = "";
      this.paymentRegistrationMsg = {};
      this.accountPayableMsg = {};
    },
    sort_fn({ prop, order }) {
      let sort = [ ...this.onSearch.sort ];
      let keyName = "";
      let sortType = "";
      // let sortIndex = -1;
      let val = "";

      if (order == "ascending") {
        sortType = "ASC";
      } else if (order == "descending") {
        sortType = "DESC";
      }

      for (let i = 0; i < this.thead.length; i++) {
        if (prop == this.thead[i].prop) {
          keyName = this.thead[i].apiProp;
          break;
        }
      }

      val = keyName + ":" + sortType;

      // for (let i = 0; i < sort.length; i++) {
      //   let thisKeyName = sort[i].substring(0, sort[i].indexOf(":"));
      //   if (thisKeyName == keyName) {
      //     sortIndex = i;
      //     break;
      //   }
      // }

      // if (sortIndex < 0) {
      //   sort.push(val);
      // } else {
      //   if (sortType == "") {
      //     sort.splice(sortIndex, 1);
      //   } else {
      //     sort[sortIndex] = val;
      //   }
      // }
      if (sortType == "") {
        sort = [];
      } else {
        sort[0] = val;
      }

      this.onSearch = { ...this.onSearch, sort: sort };
      this.getDate_fn();
    },
    theadFilter_fn() {
      this.onSearch = { ...this.onSearch, type: [ ...this.theadFilter.type ] };
      this.getDate_fn();
    },
    spanMethod({ rowIndex, columnIndex }) {
      let obj = {
        rowspan: 1,
        colspan: 1,
      };
      let dataLength = this.originalData.length;

      if (rowIndex == dataLength) {
        if (columnIndex == 4) {
          obj.colspan = 5;
        } else if (columnIndex == 5 || columnIndex == 6 || columnIndex == 7 || columnIndex == 8) {
          obj.colspan = 1;
        } else {
          obj.colspan = 0;
        }
      }

      return obj;
    },
    setCellClassName({ rowIndex, columnIndex }) {
      let dataLength = this.originalData.length;

      if (columnIndex == 5 || columnIndex == 6 || columnIndex == 7 || (columnIndex == 4 && rowIndex == dataLength)) {
        return "ta-r";
      }
    },
    refreshTable(str, isSave = true) {
      this.getDate_fn();
      if (isSave) {
        countDownAlert({ content: str });
      }
    },
    delete_fn(index) {
      const that = this;
      let { id } = that.tableData[index];
      let { name } = that.tableData[index];
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        deleteAccountPayable({ id: id }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.deleteSuccessfully") });
            that.getDate_fn();
          }
        });
      });
    },
    cancel_fn(index) {
      const that = this;
      let { id } = that.tableData[index];
      let { name } = that.tableData[index];
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.cancel")} ${name}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.confirm"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      }).then(() => {
        // confirm
        cancelAccountPayable({ id: id }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.operationSuccessful") });
            that.getDate_fn();
          }
        });
      }).catch();
    },
    showDetail(index, act = "view") {
      let dialog = { ...this.showDialog };
      let rowSpanType = this.originalData[index].type;
      let dialogMsg = JSON.parse(JSON.stringify(this.originalData[index]));
      let accountPayableId = dialogMsg.id;
      let accountPayableArr = [];

      if (rowSpanType == "ELSE_BUY") {
        dialog.otherPurchase = true;
      }
      if (rowSpanType == "BUY") {
        dialog.purchase = true;
      }
      if (rowSpanType == "TICKETING") {
        dialog.ticketing = true;
      }
      if (rowSpanType == "PROXY_BUY") {
        dialog.proxy = true;
      }

      getAccountPayablePaymentList(this.brandId, accountPayableId).then(res => {
        accountPayableArr = res.data.data;

        this.showDialog = dialog;
        this.dialogAction = act;
        this.dialogMsg = dialogMsg;
        this.accountPayableArr = accountPayableArr;
      });
    },
    async showPaymentRegistration(index, act = "create", listIndex = -1) {
      const that = this;

      const cinemaListRes = await getCinemaList();
      that.setCinemaList(cinemaListRes.data.data);

      let dialog = { ...this.showDialog, paymentRegistration: true };
      let accountPayableMsg = {};
      let paymentRegistrationAction = act;
      let paymentRegistrationMsg = {};

      if (index >= 0) {
        accountPayableMsg = JSON.parse(JSON.stringify(that.originalData[index]));
      } else {
        accountPayableMsg = JSON.parse(JSON.stringify(that.dialogMsg));
      }

      if (paymentRegistrationAction != "create") {
        paymentRegistrationMsg = JSON.parse(JSON.stringify(that.accountPayableArr[listIndex]));
      }

      that.paymentRegistrationAction = paymentRegistrationAction;
      that.paymentRegistrationMsg = paymentRegistrationMsg;
      that.accountPayableMsg = accountPayableMsg;
      that.showDialog = dialog;
    },
    refreshPaymentTable() {
      let dialog = { ...this.showDialog, paymentRegistration: false };
      let accountPayableId = this.dialogMsg.id;
      let accountPayableArr = [];

      getAccountPayablePaymentList(this.brandId, accountPayableId).then(res => {
        accountPayableArr = res.data.data;

        this.showDialog = dialog;
        this.accountPayableArr = accountPayableArr;
      });
    },
    forPaymentList(obj) {
      this.paymentItem = obj;// do some thing
      this.colsePaymentRegistrationDialog();
    },
    exportCSV_fn() {
      exportCSV({
        id: this.brandId,
      }).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = `${this.$locale("sideMenu.accountPayable.management")}.csv`;
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    approve_fn() {
      if (this.notApprove > 0) {
        const that = this;
        let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

        this.$confirm(confirmHtml, "", {
          dangerouslyUseHTMLString: true,
          showClose: false,
          showCancelButton: true,
          cancelButtonClass: "egl-btn-white",
          cancelButtonText: this.$locale("global.cancel"),
          showConfirmButton: true,
          confirmButtonClass: "egl-btn-yellow",
          confirmButtonText: this.$locale("global.approve"),
          customClass: "egl-confirm",
          closeOnClickModal: false
        }).then(() => {
          approveFn(this.brandId).then(() => {
            that.getDate_fn();
          });
        }).catch(err => {});
      }
    },
    openOffsetDialog(obj, refName) {
      this.offsetComponentRef = refName;
      this.showDialog = { ...this.showDialog, offset: true };
      this.offsetBasic = { ...obj };
    },
    closeOffsetDialog() {
      this.showDialog = { ...this.showDialog, offset: false };
    },
    setOffset(obj) {
      this.$refs[this.offsetComponentRef].setOffset(obj);
      this.closeOffsetDialog();
    },
    openOneTimePaymentDetail(basicInfo, paymentInfo, payDetails) {
      this.showDialog.oneTimePaymentDetail = true;
      this.$refs.oneTimePaymentDetail.initDailog(basicInfo, paymentInfo, payDetails);
    },
    closeOneTimePaymentDetail() {
      this.showDialog.oneTimePaymentDetail = false;
    },
    setOneTimePaymentDetaile(payDetails, obj) {
      this.$refs.oneTimePayment.setPaymentDetails(payDetails, obj);
      this.closeOneTimePaymentDetail();
    },
  },
  created() {
    getAccountReceivableListMap({
      page: 0,
      pageSize: 9999,
      field: getApiKeysField()
    }).then(res => {
      if (res.data && res.data.data) {
        this.provideAccountReceivableList = res.data.data;
      }
    });
    getClientListService({
      page: 0,
      pageSize: 20,
      field: ["id", "name"]
    }).then(res => {
      if (res.data && res.data.data) {
        this.provideClientList = res.data.data;
      }
    });
  },
  mounted() {
    let th = createColumn();
    let theadFilter = {
      type: [],
    };

    this.typeList.map(typeObj => {
      theadFilter.type.push(typeObj.value);
    });

    this.thead = th;
    this.theadFilter = theadFilter;
    this.onSearch = { ...this.onSearch, type: [ ...theadFilter.type ], brandId: this.brandId };
    this.getDate_fn();
    getSystemSetting().then(res => {
      this.roundType = res.data.round;
    });
  },
  components: {
    OtherPurchaseDialog,
    OneTimePaymentDialog,
    TicketingDialog,
    PurchaseDialog,
    ProxyDialog,
    PaymentRegistration,
    CommPagination,
    OffsetDialog,
    OneTimePaymentDetailDialog,
  },
};
</script>
